import { render, staticRenderFns } from "./Teranex.vue?vue&type=template&id=017e188d&"
import script from "./Teranex.vue?vue&type=script&lang=js&"
export * from "./Teranex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports